import { createContext, useContext } from 'react';

/**
 * Layout state for the app frame. The editor-rail and product-switcher flags
 * live here, not in their components, because the editor rail unmounts the
 * whole `NavigationBar`: "OS" on the rail must open the switcher in the same
 * render that expands it.
 */
export interface SidebarContextValue {
  isMobile: boolean;
  isMobileOpen: boolean;
  openMobile: () => void;
  closeMobile: () => void;

  /** The Process editor's rail has been expanded back to the full `NavigationBar`. */
  isEditorRailExpanded: boolean;
  setEditorRailExpanded: (
    next: boolean | ((prev: boolean) => boolean),
  ) => void;

  /** The menu shows as the icon rail: the saved choice, always on the app builder, never on phones. */
  isNavCollapsed: boolean;
  setNavCollapsed: (collapsed: boolean) => void;

  isProductSwitcherOpen: boolean;
  openProductSwitcher: () => void;
  closeProductSwitcher: () => void;
  toggleProductSwitcher: () => void;
}

export const SidebarContext = createContext<SidebarContextValue | undefined>(undefined);

export const useSidebar = (): SidebarContextValue => {
  const ctx = useContext(SidebarContext);
  if (!ctx) throw new Error('useSidebar must be used within SidebarProvider');
  return ctx;
};
